<template>
  <div class="panel panel-stretch panel-default">
    <div class="panel-heading">
      Huidige woonsituatie
    </div>
    <div class="panel-body">
      <div v-if="dataLoaded">
        <div v-if="!hasCustomerProperty && !hasProperty">
          Deze klant heeft nog geen bezoekadres, selecteer dit eerst.
        </div>
        <div style="margin-bottom:1.5rem;">
          <property-input-component ref="propertyInputComponent"
                                    v-bind:key="propertyInputKey"
                                    v-bind:default-property-id="propertyId"
                                    v-bind:emit-events="true"
                                    v-on:property-updated="handlePropertyUpdated"
                                    v-on:property-deleted="handlePropertyDeleted"
                                    v-on:property-selected="handlePropertySelected"
                                    input-name="customer_current_living_condition_property_id"
                                    :customer-id="customer.id"
          />
        </div>
        <div v-if="hasCustomerProperty">
          <a-row v-if="hasCurrentLivingCondition" v-bind:gutter="16" style="margin-bottom: 10px;">
            <a-col v-bind:span="12">
              <a-form-item label="Type bewoning">
                <a-select
                    placeholder="Type bewoning"
                    style="display: block;"
                    v-bind:aria-disabled="loadingJumba"
                    v-model="currentLivingCondition.type"
                    v-on:change="onCurrentLivingConditionChange"
                >
                  <a-select-option v-for="(occupancyName, occupancyType) in occupancyTypes"
                                   v-bind:key="occupancyType"
                                   v-bind:value="occupancyType">
                    {{ occupancyName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col v-bind:span="12">
              <a-form-item label="Automatisch aanvullen">
                <a-button type="default" v-on:click="updatePropertyWithJumba" v-bind:loading="loadingJumba">Update met
                  Jumba
                </a-button>
              </a-form-item>
            </a-col>
          </a-row>
          <customer-property-edit-component v-bind:auto-save="true"
                                            v-bind:customer-property="customerProperty"
                                            v-bind:current-living-condition="currentLivingCondition"
                                            v-bind:with-address-type="false"
                                            v-bind:property="property"
                                            v-bind:detailed="true"
                                            v-on:save="onSave"/>
          <edit-customer-current-living-condition-component v-bind:auto-save="true" v-model="currentLivingCondition"/>
          <edit-rental-component v-bind:auto-save="true" v-model="currentLivingCondition"
                                 v-if="propertyOccupancyType === 'rental' "/>
          <edit-resident-component v-bind:auto-save="true" v-model="currentLivingCondition"
                                   v-if="propertyOccupancyType === 'resident' "/>
          <edit-property-component v-bind:auto-save="true" v-model="currentLivingCondition"
                                   v-if="propertyOccupancyType === 'property' "/>
          <create-mortgage-property-component v-if="hasMortgages" v-bind:mortgages="mortgages"
                                              v-bind:property-id="property.id"
                                              v-bind:customer-id="this.customerId"/>
        </div>
        <div v-else-if="!hasCustomerProperty && loadingCustomerProperty">
          <a-row v-bind:gutter="16">
            <a-col v-bind:span="12">
              <Skeleton height="22px" width="110px" v-bind:loading="true"
                        style="display: inline-block; margin-bottom: 13px;"></Skeleton>
              <Skeleton height="32px" v-bind:loading="true"
                        style="display: block; margin-bottom: 13px;"></Skeleton>
              <Skeleton height="22px" width="110px" v-bind:loading="true"
                        style="display: inline-block; margin-bottom: 13px;"></Skeleton>
              <Skeleton height="32px" v-bind:loading="true"
                        style="display: block; margin-bottom: 13px;"></Skeleton>
              <Skeleton height="22px" width="95px" v-bind:loading="true"
                        style="display: inline-block; margin-bottom: 13px;"></Skeleton>
              <br/>
              <Skeleton height="32px" width="100px" v-bind:loading="true"
                        style="display: inline-block; margin-bottom: 13px;"></Skeleton>
              <br/>
              <Skeleton height="22px" width="170px" v-bind:loading="true"
                        style="display: inline-block; margin-bottom: 13px;"></Skeleton>
              <br/>
              <Skeleton height="32px" width="250px" v-bind:loading="true"
                        style="display: inline-block; margin-bottom: 13px;"></Skeleton>
              <br/>
            </a-col>
            <a-col v-bind:span="12">
              <Skeleton height="22px" width="200px" v-bind:loading="true"
                        style="display: inline-block; margin-bottom: 13px;"></Skeleton>
              <Skeleton height="32px" v-bind:loading="true"
                        style="display: block; margin-bottom: 13px;"></Skeleton>
              <Skeleton height="22px" width="130px" v-bind:loading="true"
                        style="display: inline-block; margin-bottom: 13px;"></Skeleton>
              <Skeleton height="32px" v-bind:loading="true"
                        style="display: block; margin-bottom: 13px;"></Skeleton>
              <Skeleton height="22px" width="95px" v-bind:loading="true"
                        style="display: inline-block; margin-bottom: 13px;"></Skeleton>
              <br/>
              <Skeleton height="32px" width="100" v-bind:loading="true"
                        style="display: inline-block; margin-bottom: 13px;"></Skeleton>
            </a-col>
          </a-row>
          <Skeleton height="80px" v-bind:loading="true"
                    style="display: block; margin-bottom: 13px;"></Skeleton>
        </div>
      </div>
      <div v-if="hasCustomerProperty">
        <a-alert
            message="Gewijzigde gegevens worden automatisch opgeslagen"
            type="info"
            show-icon
        />
      </div>
    </div>
  </div>
</template>

<script>
import customerCurrentLivingConditionApi from '~/api/customer_current_living_condition'
import customerApi from '~/api/customer'
import propertyApi from '~/api/property'
import customerPropertyApi from '~/api/customer_property'
import editCustomerPropertyComponent from '~/modules/customer_property/components/EditComponent'
import editCustomerCurrentLivingConditionComponent from './EditComponent'
import createMortgagePropertyComponent from '~/modules/mortgage_property/components/CreateComponent'
import editRentalComponent from "./EditRentalComponent";
import editResidentComponent from "./EditResidentComponent";
import editPropertyComponent from "./EditPropertyComponent";
import {Skeleton} from 'vue-loading-skeleton';

export default {
  name: "CustomerCurrentLivingConditionEditPageComponent",
  components: {
    editCustomerPropertyComponent,
    createMortgagePropertyComponent,
    editCustomerCurrentLivingConditionComponent,
    editRentalComponent,
    editResidentComponent,
    editPropertyComponent,
    Skeleton
  },
  props: {
    customerId: {
      required: true,
      type: Number
    },
  },
  data() {
    return {
      customer: null,
      property: null,
      propertyInputKey: 1,
      customerProperty: null,
      currentLivingCondition: null,
      mortgages: [],
      mortgageProperties: [],
      dataLoaded: false,
      loadingJumba: false,
      loadingCustomerProperty: false,
      occupancyTypes: {
        rental: 'Huur',
        resident: 'Inwonend',
        property: 'Eigendom',
      },
      currentLivingConditionIncludes: [
        'customer_property',
        'customer_property.property',
        'customer_property.customer',
        'customer_property.property.mortgage_properties',
        'customer_property.property.mortgage_properties.mortgage',
        'mortgages.mortgage_properties'
      ]
    };
  },
  computed: {
    hasProperty() {
      return this.property !== null;
    },
    hasMortgages() {
      return typeof this.mortgages !== "undefined" && this.mortgages !== null && this.mortgages.length > 0;
    },
    propertyId() {
      if (this.hasProperty) {
        return this.property.id
      }
      return null
    },
    hasCurrentLivingCondition() {
      return this.currentLivingCondition !== null
    },
    hasCustomerProperty() {
      return this.customerProperty !== null
    },
    propertyOccupancyType() {
      if (this.property !== null) {
        return this.currentLivingCondition.type;
      }
    }
  },
  mounted() {
    this.loadCustomer();
    this.initCurrentLivingCondition();
  },
  methods: {
    onSave(currentLivingCondition) {
      if (currentLivingCondition.is_current === false) {
        this.property = null;
        this.customerProperty = null;
      }
    },
    handlePropertyDeleted() {
      let customerProperty = this.customerProperty;
      this.property = null;
      this.customerProperty = null;

      customerProperty.is_current = false;

      customerPropertyApi.update(customerProperty).catch(error => {
      });

      this.$nextTick(() => {
        this.$refs.propertyInputComponent.handleShowPropertyCreate();
      });
    },
    handlePropertySelected(value) {
      this.property = value;
      this.loadingCustomerProperty = true;
      customerPropertyApi.findOrCreateCurrentByCustomerAndPropertyAndAddressType(this.customer.id, this.property.id, 'visit').then((response) => {
        this.initCurrentLivingConditionByProperty();
      })
    },
    handlePropertyUpdated() {
      this.initCurrentLivingConditionByProperty()
    },
    updatePropertyWithJumba() {
      if (this.property !== null) {
        this.loadingJumba = true;

        propertyApi.updateWithJumba(this.property)
            .then(response => {
              this.propertyInputKey++;
              this.property = response.data;
            })
            .finally(() => {
              this.loadingJumba = false;
            })
      }
    },
    loadCustomer() {
      customerApi.find(this.customerId).then(response => this.customer = response.data).catch();
    },
    initCurrentLivingCondition() {
      this.loadingCustomerProperty = true;
      customerCurrentLivingConditionApi.findByCustomer(
          this.customerId,
          this.currentLivingConditionIncludes
      ).then(response => {
        this.loadingCustomerProperty = false;
        this.dataLoaded = true;
        this.setCurrentLivingConditionModels(response.data);
      }).catch(error => {
        this.loadingCustomerProperty = false;
        this.dataLoaded = true;
        if (error.response.status !== 404) {
          return error;
        }
      });
    },
    initCurrentLivingConditionByProperty() {
      if (this.propertyId === null) {
        throw new Error('Property not loaded yet');
      }

      this.loadingCustomerProperty = true;

      customerCurrentLivingConditionApi.findOrCreateByCustomerAndProperty(
          this.customerId,
          this.propertyId,
          this.currentLivingConditionIncludes
      ).then(response => {
        this.setCurrentLivingConditionModels(response.data);
        this.dataLoaded = true
        this.loadingCustomerProperty = false;
      }).catch(error => {
        this.loadingCustomerProperty = false;
      });
    },
    setCurrentLivingConditionModels(currentLivingCondition) {
      this.currentLivingCondition = currentLivingCondition
      this.mortgages = this.currentLivingCondition.mortgages.data

      if (
          typeof this.currentLivingCondition.customer_property !== "undefined"
          && typeof this.currentLivingCondition.customer_property !== null
      ) {
        this.customerProperty = this.currentLivingCondition.customer_property.data
        this.customer = this.customerProperty.customer.data;
        this.property = this.customerProperty.property.data
        this.mortgageProperties = this.property.mortgage_properties.data
      }
    },
    onCurrentLivingConditionChange() {
      clearTimeout(this.persistTimeout);

      this.persistTimeout = setTimeout(() => {
        customerCurrentLivingConditionApi.update({
          id: this.currentLivingCondition.id,
          customer_property_id: this.currentLivingCondition.customer_property_id,
          type: this.currentLivingCondition.type,
        }).catch();
      }, 500);
    }
  }
}
</script>
<style scoped>
</style>
